
import {
  Box,
  HStack,
  Image,
  Spinner,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import dataicon from "../../../assets/chatbot/dataex.png";
import thinking from "../../../assets/chatbot/thinking.png";
import generating from "../../../assets/chatbot/generative.png";

function LoadingForEnterprise() {
  const loadingStatus = useSelector(
    (state) => state.agentcanvaReducer.addfinalanswerLoading
  );

  const [loadingData, setLoadingData] = useState(false);
  const [Thinking, setThinking] = useState(false);
  const [GeneratRes, setGeneratRes] = useState(false);
  const [loadingLoader, setloadingLoader] = useState(false);
  const [ThinkingLoader, setThinkingLoader] = useState(false);
  const [GeneratResLoader, setGeneratResLoader] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setLoadingData(true);
      setloadingLoader(true);
    }, 200);
    setTimeout(() => {
      setloadingLoader(false);
      setThinking(true);
      setThinkingLoader(true);
    }, 1000);
    setTimeout(() => {
      setGeneratRes(true);
      setThinkingLoader(false);
      setGeneratResLoader(true);
    }, 1500);
    setGeneratResLoader(loadingStatus);
  }, []);

  return (
    <Box>
      {loadingData && (
        <HStack gap={3} mb={"3%"}>
          <Image w={9} h={9} src={dataicon} />
          {/* <DownloadIcon w={7} h={7} color="green.500" /> */}{" "}
          {loadingLoader && <Spinner color="blue.500" />}
          <Text as={"span"} fontWeight={600}>
            Data Extraction
          </Text>
          <br />
        </HStack>
      )}

      {Thinking && (
        <HStack gap={3} mb={"3%"}>
          <Image w={8} h={8} src={thinking} />
          {ThinkingLoader && <Spinner color="blue.500" />}
          <Text as={"span"} fontWeight={600}>
            Agents are Thinking
          </Text>{" "}
          <br />
        </HStack>
      )}
      {GeneratRes && (
        <HStack gap={3} mb={"3%"}>
          <Image w={9} h={9} src={generating} />
          {GeneratResLoader && <Spinner color="blue.500" />}
          <Text as={"span"} fontWeight={600}>
            Generating the Response
          </Text>{" "}
          <br />
        </HStack>
      )}
    </Box>
  );
}

export default LoadingForEnterprise;
